var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"group",attrs:{"id":_vm.components_id},on:{"mousedown":_vm.startPoint,"mouseup":_vm.endPoint,"touchstart":_vm.startH5,"touchend":_vm.endH5}},[_c('div',{staticClass:"group_inner",style:({
            width: `${_vm.fullWidth}px`,
        }),attrs:{"id":_vm.inner_id}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }